import { IAuthTable } from './auth.interfaces';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { authAdapter } from './auth.reducer';

const {
  selectIds: _selectAuthIds,
  selectEntities: _selectAuthEntities,
  selectAll: _selectAuthAll
} = authAdapter.getSelectors();

// Selector functions
const selectAuthSelector = createFeatureSelector<IAuthTable>('auth');

export const selectAuthIds = createSelector(
  selectAuthSelector,
  _selectAuthIds
);

export const selectAuthEntities = createSelector(
  selectAuthSelector,
  _selectAuthEntities
);

export const selectAuthEntity = createSelector(
  selectAuthEntities,
  (entities, props) => entities[props.id]
 );

export const selectDefaultAuthEntity = id => createSelector(
  selectAuthEntities,
  entities => entities[id]
 );
